<template>
  <div>
    <div class="game" v-show="!reaction">


      <!-- ИНФОБЛОК -->
      <!--<infoblock></infoblock>-->

      <!-- ТЕЛО ТРЕНАЖЕРА -->
      <div class="game__body">

        <div>
          <!--<countdown></countdown>-->
          <game_body :active="active" @onFinish="onFinish"></game_body>
        </div>

        <div class="game__button">
          <button class="uk-button uk-button-primary" @click="stopGame">Закончить</button>
        </div>

      </div>


      <!-- ФИНИШ -->
      <!--<div v-if="params.finish">
        <h3>{{ success ? 'Правильно!' : 'Не вышло!' }}</h3>
        <p>{{ success ? 'Дракоша найден!' : 'Дракоша смог от тебя спрятаться! Попробуй еще разок!' }}</p>
        &lt;!&ndash;<p class="scores">И ты зарабатываешь
          <strong>{{ scores }}</strong> {{ $root.getNoun(scores, 'балл', 'балла', 'баллов') }}!</p>&ndash;&gt;
        <button class="uk-button uk-button-primary" @click="startGame" v-if="!checkFinishHomework()">Повторить!</button>
        <button class="uk-button uk-button-primary" @click="stopGame" v-else>Закончить</button>
      </div>-->

      <a href="#" @click.prevent="onStopTrainer">Остановить</a>
    </div>

    <!-- РЕАКЦИИ -->
    <!--<reaction></reaction>-->

  </div>
</template>

<script>
import { mix } from "./../mixin";
import { soundMix } from "../../../mixins/sound";
import countdown from "./modules/countdown";
import game_body from "./modules/game_body";

export default {
  name: "game",
  inject: ['TrainerMethods', 'module_name', 'http'],
  provide() {
    return {
      params: this.params
    }
  },
  mixins: [
    mix, soundMix
  ],
  data() {
    return {
      start_game: false,
      reaction: false,
      active: true,
      errors: 0
    }
  },
  components: {
    countdown, game_body
  },
  inject: ['http'],
  computed: {
    params() {
      return this.$store.state.train[this.module_name + '_params']
    },
    finish() {
      return this.params.finish
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {

    startGame() {
      this.start_game = true;
    },

    onFinish(time){
      //this.params.finish = true;
      this.makeStats(time);
      //this.addScores();
      this.onStopTrainer();
    },

    stopGame() {
      this.active = false;
    },

    /*addScores() {
      console.log('add scores');
      let sum = 0;

      let scores = +this.params.speed / 100;

      sum = Math.ceil(scores);

      if (this.$route.params.isHomework) {
        sum = Math.ceil(sum * this.$store.state.hw_coefficient);
      }
      this.checkScoreStatus(sum);
      this.scores = sum;

      this.$store.commit('changeUserScores', sum);
      console.log('Баллов заработано', sum);
    },*/
    async makeStats(time) {
      console.log("Make stats");
      if (this.user.role.code === 'student') {
        console.log('Бережно сохраняем статистику');

        let train_params = this.params;
        let stats = {
          time: time,
          errors: 0,
          user_id: this.$store.state.user.id,
          trainer: this.$store.state.current_trainer.id,
          scores: 0,
          train_params: {
            bpm: train_params.bpm,
            has_accents: train_params.has_accents
          }
        }
        stats = this.checkHomework(stats);
        let data = {
          'stat': stats
        }
        console.log('stats', stats);
        this.http.post('onSaveStats', data).then((res) => {
          console.log(res);
          this.checkCoins(res.data);
        });


      } else {
        console.log('Учителей в статистику не заносим! Понятно?!');
      }
    }
  },
  mounted() {
    //this.startGame();
  },
  beforeDestroy() {
    this.TrainerMethods.commitVal(false, 'start', this.module_name, this);
  }
}
</script>